export interface Unit {
    id: ID;
    code: string;
    name: string;
    sku?: string;
    description?: string;
    price: number;
    lineItemTemplate?: { id: ID };
    resource?: { id: ID };
    type: UnitType;
}

export enum UnitType {
    DEMOGRAPHIC = "demographic",
    DEMOGRAPHIC_SECONDARY = "demographic_secondary",
    MEMBERSHIP = "membership",
    ADDON = "merchandise",
    EQUIPMENT = "equipment",
    SERVICE = "service",
    PICKUP = "pickup",
}
